const updates = [
  {
    time: '10分钟前',
    title: '《秘密教学》第73话更新',
    desc: '最新话已上线，会长与老师的感情线迎来重大转折，评论区已经炸了！',
    tag: '韩漫更新',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '1小时前',
    title: '《咒术回战》第249话发布',
    desc: '五条悟回归剧情引爆全网，本话信息量巨大不容错过。',
    tag: '日漫更新',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '3小时前',
    title: '《斗破苍穹》全彩版第520章',
    desc: '中州篇萧炎对战魂殿强者，全彩大图战斗场面燃爆。',
    tag: '国漫更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '6小时前',
    title: '新作上线：《我在异世界开店》',
    desc: '治愈系异世界经营漫画今日首更三话，画风清新内容温暖。',
    tag: '新作推荐',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '8小时前',
    title: '韩漫排行榜本周数据更新',
    desc: '《秘密教学》连续第四周霸榜，《女神降临》完结后仍稳居前五。',
    tag: '榜单动态',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '12小时前',
    title: '《一人之下》唐门篇高潮',
    desc: '张楚岚身世之谜逐步揭开，冯宝宝真实身份引发读者激烈讨论。',
    tag: '国漫更新',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '1天前',
    title: '夏日追更活动上线',
    desc: '参与每日签到打卡即可领取阅读时长，连续签到更有漫画周边好礼相送。',
    tag: '站内活动',
    tagColor: 'bg-accent-100 text-accent-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-sm text-foreground-500">实时追踪漫画更新动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updates.map((item, i) => (
              <div key={i} className={`relative pb-8 md:pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div>
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}